import { useState, useEffect } from 'react';

function useSeo(data) {

    const [eParams, setEParams] = useState();

    if (!eParams && data) {
        setEParams(data);
    }

    const header = eParams && eParams.header ? eParams.header : global.eParams ? global.eParams.header :  'Cars for Sale';
    const contentHeader = eParams && eParams.contentHeader ? eParams.contentHeader : global.eParams ? global.eParams.contentHeader :  null;
    const description = eParams && eParams.description ? eParams.description : global.eParams ? global.eParams.description :  null;
    const images = eParams && eParams.images ? eParams.images : global.eParams ? global.eParams.images :  [];
    const links = eParams && eParams.links ? eParams.links : global.eParams ? global.eParams.links :  [];
    const dealer = eParams && eParams.dealer ? eParams.dealer : global.eParams ? global.eParams.dealer :  null;
    let options = eParams && eParams.options ? eParams.options : global.eParams ? global.eParams.options :  '';
    options = options ? options : '';

    return {header, contentHeader, description, images, links, dealer,
        options};
}

export default useSeo;
